<template>
  <div class="detail-input-wrapper">
    <div class="input-content">
      <h1>Add Details</h1>
      <div class="input-row">   

        <div v-if="!new_section">
          <label>Work Section</label>
          <select id="ms_name" name="ms_name" v-model="ms_id">
            <option :value="sec.ms_id" v-for="sec in this.section">{{ sec.ms_name }}</option>
          </select>
          <button class="addSection" @click="new_section=true">+ New</button>   
        </div>

        <div class="inputSection" v-else>
          <input type="text" v-model="new_section_name" />
          <button class="addSection" @click="new_section=false">Cancel</button>
          <button class="addSection" @click="createNewSection()">Submit</button>
        </div>

        <label>Work Type</label>
        <select id="mw_type" name="mw_type" v-model="mw_type">
          <option value="image">Image</option>
          <option value="video">Video</option>
        </select>
      </div>

      <div class="input-row">
        <label>Thumbnail Link</label>
        <textarea id="mw_thumb" name="mw_thumb" rows="2" cols="20" type="text" v-model="mw_thumb"></textarea>

        <label>Original Link</label>
        <textarea id="mw_src" name="mw_src" rows="2" cols="20" type="text" v-model="mw_src"></textarea>

        <label>Sort Order</label>
        <input id="mw_sort" name="mw_sort" type="text" v-model="mw_sort">
      </div>

      <button type="submit" @click="submitDetail" class="bttn">Submit</button>
      <button type="submit" @click="closeAdd" class="bttn closeAdd">Close</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  created () {

  },
  props: [
    'select_maker'
  ],
  data() {
    return {
      m_id: '',
      ms_id: '',
      mw_type: '',
      mw_thumb: '',
      mw_src: '',
      mw_sort: '',
      works: [],
      section: [],
      new_section: false,
      new_section_name: '',
      works: [],
    }
  },
  mounted() {
    
  },

  methods: {
    getData() {
      axios.get('/api/maker_works')
        .then((response) => {
          this.works = response.data
        })
    },

    getSection() {
      axios.get('/api/maker_section/' + this.m_id )
        .then((response) => {
          this.section = response.data
        })
    },

    createNewSection() {
      axios.post('/api/maker_section_new_name', {
        m_id: this.m_id,
        ms_name: this.new_section_name,
      }).then((response) => {
        this.new_section_name = ''
        this.new_section = false
        this.getSection()
      })
    },
    // getWork() {
    //   axios.get('/api/maker_works/' + this.m_id)
    //     .then((response) => {
    //       this.works = response.data
    //     })
    // },
    // updateSort() {
    //   this.works.map((work, index) => {
    //     work.mw_sort = index + 1
    //   })

    //   axios.put('/api/maker_works/updateSort', {
    //     works: this.works
    //   }).then((response) => {
    //     this.getWork()
    //     console.log(response)
    //   })
    // },

    submitDetail() {
      axios.post('/api/maker_works', {
        m_id: this.m_id,
        ms_id: this.ms_id,
        mw_type: this.mw_type,
        mw_thumb: this.mw_thumb,
        mw_src: this.mw_src,
        mw_sort: this.mw_sort,
      }).then((response) => {
        console.log(response.data)
        if(response.data.affectedRows == 1) {
          this.getData()
          // this.updateSort()
        }
        this.ms_id = ''
        this.mw_type = ''
        this.mw_thumb = ''
        this.mw_src = ''
        this.mw_sort = ''
      }).catch(e => {
        console.log(e)
      })
      var modal = document.querySelector('.detail-input-wrapper')
      modal.style.display = "none"
    },
     closeAdd() {
      var modal = document.querySelector('.detail-input-wrapper')
      modal.style.display = "none"
    },
  },
  watch: {
    select_maker(arr) {
      this.m_id = arr.m_id
      this.getSection()
    }
  }
}
</script>
<style lang="scss" scoped>
.detail-input-wrapper {
  display: none;
  position: fixed;
  padding-top: 70px;
  top: 0;
  left: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,.5);
  z-index: 1;

  .input-content {  
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 50px 50px 80px 50px;
    border: 1px solid #888;
    width: 35%;
    .input-row {
      margin-bottom: 20px;
    }
    select {
      min-width: 100px;
    }
    label {
      width: 120px;
    }
    h1 {
      padding: 10px 10px 30px 10px;
    }
    input {
      width: 100%;
    }
    textarea {
      border-color:rgb(186,186,186);
      width: 100%;
    }
    .inputSection {
      margin-bottom: 15px;
      width: 200px;
    }

    button {
      margin-top: 20px;
      margin-right: 10px;
      background: none;
      border-radius: 5%;
      padding: 5px 15px;
      width: 100px;
      position: relative;
    }
    .addSection {
      margin-top: 7px;
      margin-right: 10px;
      background: none;
      // border-radius: 5%;
      padding: 0px;
      width: 80px;
    }
    .bttn {
      // position: absolute;
      // right: 50px;
      // top: 517px;
      margin: 12px 0 0 15px;;
      float: right;
    }
    .closeAdd {
      color: #fff;
      background-color: #eb8b57;
      // right: 164px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/DetailForm.vue